import { render } from "./keywordModal.vue?vue&type=template&id=9364ac98&scoped=true&ts=true"
import script from "./keywordModal.vue?vue&type=script&lang=ts"
export * from "./keywordModal.vue?vue&type=script&lang=ts"

import "./keywordModal.vue?vue&type=style&index=0&id=9364ac98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9364ac98"]])

export default __exports__